<app-loader></app-loader>
<app-error-page></app-error-page>
@if (userLoad) {
  <nav class="navbar navbar-expand-lg navbar-light fixed-top">
    <div class="container-fluid">
      <!-- Mobile mode: burger menu-->
      <div class="d-flex">
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
      <!-- Sircle's logo-->
      <div class="d-flex nav-item-sircle">
        <a routerLink="/">
          <img [src]="'../assets/imgs/logo' + getTheme() + '.fdc7b75d.png'" alt="Logo" />
        </a>
      </div>
      <!-- Language Dropdown-->
      <div class="d-flex nav-item-lang-icon dropdown" routerLinkActive #rlaUser="routerLinkActive">
        <a
          class="nav-link"
          id="languageDropdown"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <svg class="nav-link-icon">
            <use href="feather-sprite.svg#globe" />
          </svg>
        </a>
        <ul class="dropdown-menu" aria-labelledby="languageDropdown">
          @for (lang of availableLangs; track lang) {
            <li>
              <a
                class="dropdown-item"
                [ngClass]="currentLanguage === lang ? 'active-language' : ''"
                (click)="selectLanguage(lang)"
                (keyup.enter)="selectLanguage(lang)"
                tabindex="0"
              >
                {{ 'NAVBAR.LANGUAGE.LANGUAGES.' + lang.toUpperCase() | transloco }}</a
              >
            </li>
          }
        </ul>
      </div>
      <!-- Burger menu elements -->
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <!-- My Sircles Dropdown -->
          <li class="dropdown nav-item" routerLinkActive #rlaSircles="routerLinkActive">
            <a
              class="nav-link dropdown-toggle"
              id="mySirclesDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <div>
                <span
                  class="onhover"
                  [ngClass]="{
                    active: rlaSircles?.isActive
                  }"
                >
                  {{ 'NAVBAR.SIRCLES' | transloco }}</span
                >
                <svg class="nav-link-icon icon-rotates">
                  <use href="feather-sprite.svg#chevron-down" />
                </svg>
              </div>
            </a>
            <ul class="dropdown-menu" aria-labelledby="mySirclesDropdown">
              @for (sircle of userData.menu; track sircle) {
                <li>
                  <a class="dropdown-item" [routerLink]="'sircles/' + sircle.slugName">
                    {{ sircle.name }}
                    @if (sircle.coreMember || sircle.isLeader) {
                      <svg
                        [ngClass]="{
                          'circle-icon-core': sircle.coreMember,
                          'circle-icon-leader': sircle.isLeader
                        }"
                      >
                        <use href="feather-sprite.svg#disc" />
                      </svg>
                    }
                  </a>
                </li>
              }
            </ul>
          </li>
          <!-- My roles Dropdown -->
          <li class="dropdown nav-item" routerLinkActive #rlaRoles="routerLinkActive">
            <a
              class="nav-link dropdown-toggle"
              id="myRolesDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              ><span
                class="onhover"
                [ngClass]="{
                  active: rlaRoles?.isActive
                }"
              >
                {{ 'NAVBAR.ROLES' | transloco }}</span
              >
              <svg class="nav-link-icon icon-rotates">
                <use href="feather-sprite.svg#chevron-down" />
              </svg>
            </a>
            <ul class="dropdown-menu" aria-labelledby="myRolesDropdown">
              @for (sircle of userData.menu; track sircle; let i = $index) {
                @if (i > 0) {
                  <hr class="dropdown-divider" />
                }
                <li>
                  <p
                    class="dropdown-header dropdown-header-display"
                    (click)="stopPropagation($event)"
                    (keyup.enter)="stopPropagation($event)"
                    tabindex="0"
                  >
                    {{ sircle.name }}
                  </p>
                  @if (sircle.coreMember || sircle.isLeader) {
                    <svg
                      [ngClass]="{
                        'circle-icon-core': sircle.coreMember,
                        'circle-icon-leader': sircle.isLeader
                      }"
                    >
                      <use href="feather-sprite.svg#disc" />
                    </svg>
                  }
                </li>
                @for (role of sircle.roles; track role) {
                  <li>
                    <a class="dropdown-item" [routerLink]="'roles/' + role.id">
                      <svg class="list-icon">
                        <use href="feather-sprite.svg#circle" />
                      </svg>
                      {{ role.name }}
                    </a>
                  </li>
                }
              }
            </ul>
          </li>
        </ul>
        <!--Right side Search/Lenguage/Logout-->
        <div class="d-lg-inline-flex">
          <ul class="navbar-nav ml-auto me-auto mb-2 mb-lg-0">
            <!-- Search -->
            <form class="d-flex nav-item" (keydown.enter)="$event.preventDefault()">
              <input
                type="search"
                class="nav-item-search form-control"
                [placeholder]="'NAVBAR.SEARCH' | transloco"
                (keyup)="search(searchInput.value)"
                name="searchInput"
                #searchInput
                aria-label="Search input"
                aria-describedby="Search input"
              />
            </form>
            <!-- User: logout and light/dark mode set-up -->
            <li
              class="dropdown nav-item nav-item-user"
              routerLinkActive
              #rlaUser="routerLinkActive"
            >
              <a
                class="nav-link dropdown-toggle"
                id="userDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  [src]="(userData.avatar ?? getDefaultAvatar(userData.username)) + '?s=100'"
                  alt="user Savatar"
                  class="savatar-img"
                />
                <span
                  class="onhover padding"
                  [ngClass]="{
                    active: rlaUser?.isActive
                  }"
                >
                  {{ userData.username }}</span
                >
                <svg class="nav-link-icon icon-rotates">
                  <use href="feather-sprite.svg#chevron-down" />
                </svg>
              </a>
              <ul class="dropdown-menu dropdown-menu-end">
                @if (userData.isAdmin) {
                  <li>
                    <a class="dropdown-item" [routerLink]="'no-core-members'">
                      {{ 'NAVBAR.NO_CORE_MEMBERS' | transloco }}
                    </a>
                  </li>
                }
                <li>
                  <a class="form-check form-switch dropdown-item">
                    @if (currentTheme === 'light-theme') {
                      <label class="form-check-label" for="switchIntExt">
                        {{ 'NAVBAR.THEME.DARK_THEME' | transloco }}
                      </label>
                    }
                    @if (currentTheme === 'dark-theme') {
                      <label class="form-check-label" for="switchIntExt">
                        {{ 'NAVBAR.THEME.LIGHT_THEME' | transloco }}
                      </label>
                    }
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="switchIntExt"
                      [checked]="currentTheme === 'dark-theme'"
                      (click)="toggleTheme()"
                    />
                  </a>
                </li>
                <hr />
                <li>
                  <a class="dropdown-item" (click)="logout()" (keyup.enter)="logout()" tabindex="0">
                    {{ 'NAVBAR.LOGOUT' | transloco }}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
  <div class="mt"></div>
  <router-outlet></router-outlet>
}
